import React, { useContext } from "react";

import Messages from "./Messages";
import Input from "./Input";
import { ChatContext } from "../ChatContext";

const Chat = () => {
  const { data } = useContext(ChatContext);

  return (
    <div className="chat">
      <div className="chatInfo">
      <img src={data.user?.photoURL} alt=""></img>
        <span>{data.user?.displayName}</span>
        <div className="chatIcons">
         
        </div>
      </div>
      <Messages />
      <Input/>
    </div>
  );
};

export default Chat;
